import { provideAnimations } from "@angular/platform-browser/animations";
import { provideRouter } from "@angular/router";
import {
  LucideAnchor,
  LucideArrowLeft,
  LucideArrowRight,
  LucideBookOpen,
  LucideCheck,
  LucideCheckCircle,
  LucideChevronDown,
  LucideCircleCheck,
  LucideCircleCheckBig,
  LucideCircleX,
  LucideClipboardList,
  LucideClock,
  LucideCoins,
  LucideCompass,
  LucideCrown,
  LucideFlag,
  LucideFlame,
  LucideGlobe,
  LucideHome,
  LucideImage,
  LucideInfo,
  LucideLoaderCircle,
  LucideLock,
  LucideLogOut,
  LucideMail,
  LucideMap,
  LucideMapPin,
  LucideMedal,
  LucideMinus,
  LucideMousePointer2,
  LucideMove,
  LucidePlay,
  LucidePlus,
  LucideRotateCcw,
  LucideRoute,
  LucideSave,
  LucideSettings,
  LucideShield,
  LucideShip,
  LucideStar,
  LucideStore,
  LucideTarget,
  LucideTimer,
  LucideTrash2,
  LucideTruck,
  LucideTrophy,
  LucideUpload,
  LucideUser,
  LucideUserPlus,
  LucideUsers,
  LucideWaves,
  LucideX,
  LucideZoomIn,
  LucideZoomOut,
  provideLucideIcons,
} from "@lucide/angular";
import { routes } from "./app.routes";

export const appConfig = {
  providers: [
    provideRouter(routes),
    provideAnimations(),
    provideLucideIcons(
      LucideAnchor,
      LucideArrowLeft,
      LucideArrowRight,
      LucideBookOpen,
      LucideCheck,
      LucideCheckCircle,
      LucideChevronDown,
      LucideCircleCheck,
      LucideCircleCheckBig,
      LucideCircleX,
      LucideClipboardList,
      LucideClock,
      LucideCoins,
      LucideCompass,
      LucideCrown,
      LucideFlag,
      LucideFlame,
      LucideGlobe,
      LucideHome,
      LucideImage,
      LucideInfo,
      LucideLoaderCircle,
      LucideLock,
      LucideLogOut,
      LucideMail,
      LucideMap,
      LucideMapPin,
      LucideMedal,
      LucideMinus,
      LucideMousePointer2,
      LucideMove,
      LucidePlay,
      LucidePlus,
      LucideRotateCcw,
      LucideRoute,
      LucideSave,
      LucideSettings,
      LucideShield,
      LucideShip,
      LucideStar,
      LucideStore,
      LucideTarget,
      LucideTimer,
      LucideTrash2,
      LucideTruck,
      LucideTrophy,
      LucideUpload,
      LucideUser,
      LucideUserPlus,
      LucideUsers,
      LucideWaves,
      LucideX,
      LucideZoomIn,
      LucideZoomOut,
    ),
  ],
};
